import React from 'react';
import CustomFileCard from '../CustomFileCard';
import {toast} from 'react-toastify';
import {DeleteFileById} from '../../reduxToolkit/fileUpload/FileUploadApi';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {downloadActionFile, downloadLocalFile, formatBytes, getIconByExtOrFile} from '../../Apis/functions';

/**
 * Component to display the list of selected files, including photos taken with the camera.
    They are displayed as cards and use the CustomFileCard component

 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model photoPickerFile: component model
 * @param useState setPhotoPickerFile: state to update the component model
 * @param showBtnDeleteItemGallery: If true, the delete icon is displayed in the file gallery
 * @param {boolean} [showBtnDownload=false] - If true, displays the download button in each file card.
 * @param {React.ComponentType|JSX.Element|null} [downloadIcon=null] - Custom download icon (optional).
 * @param {React.ComponentType|JSX.Element|null} [deleteIcon=null] - Custom delete icon (optional).
 * @param {boolean} [disabled=false] - Disables delete action when true.
 * @param {boolean} [apiDelete=true] - If true, deletes files using API; otherwise deletes locally.
 *
 */
const FilesGallerySummary = ({
    photoPickerFile,
    setPhotoPickerFile,
    showBtnDeleteItemGallery,
    deleteIcon = null,
    downloadIcon = null,
    showBtnDownload = false,
    disabled=false,
    apiDelete=true
}) => {


    const dispatch = useDispatch();
    const { t } = useTranslation();

    const deleteInList = (index) => {
        setPhotoPickerFile(prev => {
            const newList = [...prev.listFiles];
            newList.splice(index, 1);
            return {
                ...prev,
                listFiles: newList
            };
        });
        toast.success(t("has_been_deleted_successfully"))
    }

    const handleDeleteByItem = (e, item, index) => {
        e.preventDefault();
        if(item.id != null){
            dispatch(DeleteFileById(item.id)).then(({payload: {data: { success }}}) => {
                if(success){
                    deleteInList(index);
                }
            })
        }else{
            deleteInList(index);
        }
    };

    return (
        <div className="row w-100 m-0 p-0 maxh-135px overflow-y-auto">
            { photoPickerFile?.listFiles?.length > 0 &&
                <>
                    {photoPickerFile?.listFiles?.map((item, index) => {
                        let fileSelected = item?.fileSelected;
                        let Icon =  getIconByExtOrFile(fileSelected);
                        let kb = fileSelected ? formatBytes(fileSelected.size) : "--"

                        return (
                            <div className="col-12 my-2 px-0 mx-0" id={`div_pfpm_${index}`} key={`div_key_pfpm_${index}`}>
                                <CustomFileCard
                                    Icon={Icon}
                                    title={fileSelected?.name || ''}
                                    subtitle={kb}
                                    buttonId={"btn_fgs_delete_item" }
                                    clickBtnDelete={(e) => {
                                        if(apiDelete){
                                            handleDeleteByItem(e,item,index)
                                            return;
                                        }
                                        deleteInList(index);
                                    }}
                                    showBtnDelete={disabled ? false: showBtnDeleteItemGallery}
                                    onClick={()=> {
                                        item?.id ? downloadActionFile(item?.fileSelected?.url) : downloadLocalFile(item?.fileSelected)
                                    }}
                                    fileValue={fileSelected?.name}
                                    showBtnDownload={showBtnDownload}
                                    classContent="px-0 py-0"
                                    downloadIcon={downloadIcon}
                                    deleteIcon={deleteIcon}
                                />
                            </div>
                        )
                    })}
                </>
            }
        </div>
    )

}

export default FilesGallerySummary;
